import { render, staticRenderFns } from "./UnauthorizedOverlay.vue?vue&type=template&id=28e33006&"
import script from "./UnauthorizedOverlay.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e33006')) {
      api.createRecord('28e33006', component.options)
    } else {
      api.reload('28e33006', component.options)
    }
    module.hot.accept("./UnauthorizedOverlay.vue?vue&type=template&id=28e33006&", function () {
      api.rerender('28e33006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay/UnauthorizedOverlay.vue"
export default component.exports